import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="places"
export default class extends Controller {
  static targets = ['name', 'placeId', 'lat', 'lon', 'postalCode',
    'streetNumber', 'ambiguousWarning']

  connect() {
    this.prevNameValue = this.nameTarget.value
    if (typeof google != 'undefined') {
      this.initPlacesAutocomplete()
    }
  }

  initPlacesAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.nameTarget, {
      componentRestrictions: { country: ['pl'] },
      fields: ['address_components', 'geometry', 'place_id', 'formatted_address'],
      types: ['address']
    })
    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace()
      this.placeChanged(place)
    })
  }

  placeChanged(place) {
    if (!place.address_components) {
      this.prevNameValue = ''

      this.nameTarget.value         = ''
      this.placeIdTarget.value      = ''
      this.latTarget.value          = ''
      this.lonTarget.value          = ''
      this.streetNumberTarget.value = ''
      this.postalCodeTarget.value   = ''

      return
    }

    this.prevNameValue = this.nameTarget.value

    const components = this.extractComponents(place)

    if (components.street_number) {
      this.ambiguousWarningTarget.style.display = 'none'
    } else {
      this.ambiguousWarningTarget.style.display = null
    }

    this.prevNameValue = place.formatted_address

    this.nameTarget.value         = place.formatted_address
    this.placeIdTarget.value      = place.place_id
    this.latTarget.value          = place.geometry.location.lat()
    this.lonTarget.value          = place.geometry.location.lng()
    this.streetNumberTarget.value = components.street_number || ''
    this.postalCodeTarget.value   = components.postal_code || ''
  }

  keydown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      event.target.blur()
    }
  }

  blur() {
    this.nameTarget.value = this.prevNameValue
  }

  extractComponents(place) {
    const parsed = {}
    for (const component of place.address_components) {
      const componentType = component.types[0]

      switch (componentType) {
        case 'street_number': {
          parsed['street_number'] = component.long_name
          break;
        }

        case 'postal_code': {
          parsed['postal_code'] = component.long_name
          break;
        }
      }
    }

    return parsed
  }

  populate(event) {
    const placeId = event.detail.placeId
    if (!placeId) {
      console.warn('No placeId in event details')
      return
    }

    if (!this.geocoder) {
      this.geocoder = new google.maps.Geocoder()
    }

    this.geocoder.geocode({ placeId: placeId }).then(({ results }) => {
      if (!results[0]) return

      this.placeChanged(results[0])
    })
  }
}
